import { render, staticRenderFns } from "./layout_blank.vue?vue&type=template&id=f3838198&scoped=true&"
import script from "./layout_blank.vue?vue&type=script&lang=js&"
export * from "./layout_blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3838198",
  null
  
)

export default component.exports